<div class="app-timesheet-logs">
  <table mat-table [dataSource]="timelogs$ | async" class="card-table">
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>DATE</th>
      <td mat-cell *matCellDef="let timesheet">{{ timesheet.date }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>PROJECT/LOCATION</th>
      <td mat-cell *matCellDef="let timesheet">
        {{ timesheet.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="clock_in">
      <th mat-header-cell *matHeaderCellDef>CLOCK IN</th>
      <td mat-cell *matCellDef="let timesheet">
        {{ timesheet.clock_in }}
      </td>
    </ng-container>

    <ng-container matColumnDef="clock_out">
      <th mat-header-cell *matHeaderCellDef>CLOCK OUT</th>
      <td mat-cell *matCellDef="let timesheet">
        {{ timesheet.clock_out }}
      </td>
    </ng-container>

    <ng-container matColumnDef="units">
      <th mat-header-cell *matHeaderCellDef>UNITS</th>
      <td mat-cell *matCellDef="let timesheet">
        {{ timesheet.units }}
      </td>
    </ng-container>

    <ng-container matColumnDef="break_start">
      <th mat-header-cell *matHeaderCellDef>BREAK START</th>
      <td mat-cell *matCellDef="let timesheet">
        {{ timesheet.break_start }}
      </td>
    </ng-container>

    <ng-container matColumnDef="break_end">
      <th mat-header-cell *matHeaderCellDef>BREAK END</th>
      <td mat-cell *matCellDef="let timesheet">
        {{ timesheet.break_end }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" style="text-align: center" colspan="3">
        No data found
      </td>
    </tr>
  </table>
</div>
